module.exports = __webpack_public_path__ + "static/img/14.e6d57b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/14.png
// module id = V1zv
// module chunks = 0